import type { I18nFn } from '#/i18n/types/I18nFn';

import { LISTING_TYPE_HUMAN_NAME_MAP } from './listingTypeHumanNameMap';
import type { ListingTypeKeys } from './listingTypeHumanNameMap';

export type ObjectTypeKeys =
  | ListingTypeKeys
  | 'ARTICLE'
  | 'INVOICE'
  | 'PAYMENT'
  | 'DONATION';

export function OBJECT_TYPE_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    ...LISTING_TYPE_HUMAN_NAME_MAP(i18n),
    ARTICLE: i18n('article'),
    INVOICE: i18n('invoice'),
    PAYMENT: i18n('payment'),
    DONATION: i18n('donation'),
  };
}
